import Space from 'antd/lib/space';
import Typography from 'antd/lib/typography';
import React from 'react';
import { AppStoreAvailableBuild } from '../../../types';
import { AppBuildComponent, CIBuildComponent } from '../../BuildComponents';
import LinkageIcon from '../../icons/LinkageIcon';

export const SelectedAppStoreBuild = (props: {
    build: AppStoreAvailableBuild;
    styleOverrides?: React.CSSProperties;
}) => {
    const { build, styleOverrides } = props;
    return (
        <Space style={{ ...styleOverrides }}>
            <AppBuildComponent
                integrationId={build.appStoreBuild.integrationId}
                buildIdentifier={build.appStoreBuild.buildNumber}
                type={build.appStoreBuild.type}
                isProcessed={build.appStoreBuild.isProcessed}
            />
            <LinkageIcon width={16} height={16} />
            {build.associatedCIBuild && (
                <CIBuildComponent
                    integrationId={build.associatedCIBuild.integrationId}
                    buildIdentifier={build.associatedCIBuild.buildIdentifier}
                />
            )}
            {!build.associatedCIBuild && <Typography.Text type="secondary">Unknown</Typography.Text>}
        </Space>
    );
};
